<template>
  <router-view></router-view>
</template>
<script>
import { mapGetters } from "vuex";
import { loadLanguageAsync } from "@/plugins/i18n";
import { API_LOCALE } from "@/constants/constants";

export default {
  name: "Home",
  computed: {
    ...mapGetters({
      user: "user/profile",
      roles: "user/roles",
    }),
  },
  watch: {
    async user(newValue) {
      if (newValue.language) {
        await loadLanguageAsync(newValue.language);
      }
    },
    $route: {
      immediate: true,
      handler() {
        if (process.env.NODE_ENV === "development") {
          document.title = this.$route.name
            ? `${this.$t(this.$route.name)} | Haldusnet`
            : "Haldusnet";
        }
      },
    },
  },
  async mounted() {
    this.$wait.start("labels");
    const cookieLang = this.$cookies.get("sessionLang");
    let sessionLang = process.env.VUE_APP_I18N_LOCALE;
    if (this.$route.params.locale) {
      const twoLetter = API_LOCALE.filter((obj) => {
        return obj.key === this.$route.params.locale;
      });
      sessionLang = twoLetter[0].value;
    } else if (cookieLang) {
      sessionLang = cookieLang;
    }
    await loadLanguageAsync(sessionLang);
    this.$wait.end("labels");
  },
};
</script>
